import { AxDropdown, IAxDropdownOptions } from "@axess/limestone";
import { AxDatePicker, Mode, Cell } from "../../../../Components/AxDatepicker/AxDatepicker";
import { IRentalDetailInitData } from "../../../../Models/Rental/Details/RentalDetailInitData";
import { RentalProdSelectionTimings } from "../../../../Models/Rental/Details/RentalProdSelectionTimings";
import { RentDetailsProdSelectCompManager } from "../Services/RentDetailsProdSelectCompManager";

export class RentDetailsProdSelectTimings {

    private startDatePicker = new AxDatePicker();
    private startDateDropDown = new AxDropdown();
    private durationDropDown = new AxDropdown();
    private pickUpTimeDropDown = new AxDropdown();

    private datePattern: string;
    private selectionTimings: RentalProdSelectionTimings;
    private prodSelectComponentManager: RentDetailsProdSelectCompManager;

    constructor(init: IRentalDetailInitData, prodSelectComponentManager: RentDetailsProdSelectCompManager) {
        this.selectionTimings = new RentalProdSelectionTimings();
        this.prodSelectComponentManager = prodSelectComponentManager;
        this.initEvents(init);
    }

    private initEvents(init: IRentalDetailInitData) {
        this.datePattern = init.datePattern;

        this.initStartDatePicker(init);
        this.initDurationDropDown();
        this.initPickUpTimesDropDown();
    }

    getSelectedTimings(): RentalProdSelectionTimings {
        return this.selectionTimings;
    }

    private loadProductSelectionComponent() {
        this.prodSelectComponentManager.loadRentDetailsProdSelectComponent(this.selectionTimings);
    }

    private initStartDatePicker(init: IRentalDetailInitData) {
        this.startDatePicker = new AxDatePicker();

        const endDate = init.endDate != null ? moment(init.endDate, "YYYY-MM-DD") : null;

        this.startDatePicker.Init({
            StartOfWeek: init.startOfWeek,
            Lang: init.lang,
            StartDate: moment(init.startDate, "YYYY-MM-DD"),
            DayRange: 0,
            Target: '#rental__startDate-picker',
            Mode: Mode.Inline,
            EndDate: endDate,
            monthsShown: 1
        });

        this.startDateDropDown.init(`.rental_details__date`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: ($parent: JQuery<HTMLElement>) => {
                    //@ts-ignore
                    const instance = $parent[0]._tippy as Instance<Props>;
                    let $popper = $(instance.popper);
                    $popper.css('width', 'auto');
                }
            });

        this.startDatePicker.ActivationSubject.subscribe(x => { this.onSelectStartDatePicker(x); });
    }


    private onSelectStartDatePicker(cell: Cell) {
        if (cell != null) {
            const dateValue = cell.Date.format(this.datePattern);
            this.startDateDropDown.setValue(dateValue);
            this.startDateDropDown.close();
            this.selectionTimings.startSoapDate = cell.Date.format("YYYY-MM-DD");
            this.loadProductSelectionComponent();
        }
    }

    private initDurationDropDown() {
        this.durationDropDown.init(`.rental_details__duration`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: (elem: any) => { this.onSelectDurationDropDown(elem) }
            });
    }

    private onSelectDurationDropDown(elem: any) {
        this.selectionTimings.durationIdentifier = this.durationDropDown.getValue().toString();
        this.loadProductSelectionComponent();
    }

    private initPickUpTimesDropDown() {
        this.pickUpTimeDropDown.init(`.rental_details__pickUpTime`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: (elem: any) => { this.onSelectPickUpTimesDropDown(elem) }
            });
    }

    private onSelectPickUpTimesDropDown(elem: any) {
        this.selectionTimings.pickUpTimeId = parseInt(this.pickUpTimeDropDown.getValue().toString());
        this.loadProductSelectionComponent();
    }
}